import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="custom-navbar">
      <Container>
        <Row>
          <Col xs={12} md={4} className="text-center text-md-left">
            <p className="mb-0 text-white custom-font">Phone: 951-285-8867</p>
          </Col>
          <Col xs={12} md={4} className="text-center">
            <p className="mb-0 text-white custom-font">Delivering Fresh Bakery Goods</p>
          </Col>
          <Col xs={12} md={4} className="text-center text-md-right">
            <a href="/contact" className="text-white custom-font">Contact Us</a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
